import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { isNullOrEmpty, translate } from '../../../../utils/util';
import ContainerService from '../../../../services/ContainerService';
import { Breadcrumbs, Button, Table } from '../../../../components/UI/ComponentsUI'
import { onValueChange, validateInputsRequired } from '../../../../utils/handleChangeHooks';
import SpawningContainerAviexp from './SpawningContainerAviexp';
import useStateWithPromise from '../../../../utils/useEffectUpdate';
import { getVision } from '../../../../services/auth';
import { VISIONS } from '../../../../utils/constants';
import SpawningPhysicalConfirmation from './SpawningPhysicalConfirmation';

const SpawningContainer = (props) => {
    const dataParams = props.history?.location?.state?.dataParams
    const [container, setContainer] = useState({});
    const [containers, setContainers] = useState([]);
    const [area, setArea] = useState({});
    const [filter, setFilter] = useStateWithPromise({
        name: dataParams?.name.toString() || "",
        unloadLocationId: dataParams?.unloadLocationId?.toString() || "",
        spawning: false
    });
    const [currentPage, setCurrentPage] = useState({ pageSize: 10, pageIndex: 0, sortField: "", sortOrder: 0 });

    useEffect(() => {
        if (!isNullOrEmpty(filter.name)) {
            searchContainer();
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        onSearch(false);
        // eslint-disable-next-line
    }, [currentPage]);

    useEffect(() => {
        setContainers(props.containers?.items || []);
        // eslint-disable-next-line
    }, [props?.containers?.items]);

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const onSearch = () => {
        props.getPagedList({
            status: [6], // “TRANSITO DOCA” 
            sortField: currentPage.sortField,
            sortOrder: currentPage.sortOrder,
            PageSize: currentPage.pageSize,
            PageIndex: currentPage.pageIndex
        });
    }


    const searchContainer = () => {
        if (validateInputsRequired('getOrigem')) {
            props.getContainer(filter, (response) => {
                if (response) {
                    response.unloadLocationId = isNullOrEmpty(filter.unloadLocationId) ? response.unloadLocationId : filter.unloadLocationId;
                    setContainer(response);
                    const responseArea = {};
                    Object.assign(responseArea, response);
                    responseArea.containerItem = [];
                    setArea(responseArea);
                }
            })
        }
    }

    const sendChange = () => {
        props.sendContainerSpawning(area, () => {
            setFilter({ spawning: false });
            setContainer({});
            setArea({});

            if (!isNullOrEmpty(dataParams?.name)) {
                props.history.go(-1);
            }
        });
    };

    const configColumn = () => {
        const cols = [
            {
                field: 'name',
                header: 'Nome Container',
                align: 'left',
                sortable: true
            },
            {
                field: 'statusDescription',
                header: 'Status',
                align: 'left',
            },
            {
                field: 'freeTimeAvailable',
                header: 'FreeTime Disponível',
                align: 'center',
                sortable: true
            },
        ];
        return cols;
    };

    return (
        <div>
            <Breadcrumbs
                title={{ icon: "mdi mdi-view-dashboard-outline", label: translate('container:menu:spawning') }} />

            <div className="container-fluid" style={{ marginTop: '30px' }}>
                <div className="container">
                    {
                        getVision() === VISIONS.Palomar || getVision() === VISIONS.PortoReal ?
                            <>
                                <SpawningContainerAviexp
                                    searchContainer={searchContainer}
                                    filter={filter}
                                    setFilter={setFilter}
                                    onChange={onChange}
                                    container={container}
                                    area={area}
                                    setContainer={setContainer}
                                    setArea={setArea} />
                                {
                                    container?.id &&
                                    <div className="row">
                                        <Button full="true" onClick={() => sendChange()} text={'Confirmar Desova'} />
                                    </div>
                                }
                            </> :
                            <SpawningPhysicalConfirmation />
                    }
                </div>

                {
                    !container.id && (getVision() === VISIONS.Palomar || getVision() === VISIONS.PortoReal) && <div id="items" className="container-fluid">
                        <Table
                            totalPages={props.list?.totalPages}
                            current={{ currentPage, setCurrentPage }}
                            col={configColumn()}
                            data={containers}
                            onClickRow={(evt) => {
                                filter.name = evt.name
                                setFilter({ ...filter }).then(() => {
                                    searchContainer();
                                })
                            }}
                        />
                    </div>
                }
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        containers: state.containerReducer.containers
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPagedList: (filter) => {
            dispatch(ContainerService.getContainerPaged(filter));
        },
        getContainer: (filter, callback) => {
            dispatch(ContainerService.getContainerChange(filter, callback));
        },
        sendContainerSpawning: (data, callback) => {
            dispatch(ContainerService.sendContainerSpawning(data, callback));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SpawningContainer));